import * as Schema from "effect/Schema";
import * as Effect from "effect/Effect";

import { TrimmedNonEmptyString } from "./baseSchemas.ts";

const DESIGN_SYSTEM_AUTHORITY_PATH_PATTERN =
  /^\.afar-research\/design\/design-system\/(?!\.{1,2}(?:\/|$))[^/\r\n]+\/DESIGN\.md$/;

export const DesignSystemMentionPath = TrimmedNonEmptyString.check(
  Schema.isMaxLength(512),
  Schema.isPattern(DESIGN_SYSTEM_AUTHORITY_PATH_PATTERN),
);
export type DesignSystemMentionPath = typeof DesignSystemMentionPath.Type;

export const DesignSystemMention = Schema.Struct({
  type: Schema.Literal("design-system"),
  /**
   * The Design System's stable storage identity, as its `DESIGN.md` records it.
   * A rename moves the directory and changes the name but preserves this, so a
   * mention still being *held* can be resolved back to what it points at.
   * Optional: mentions picked before this, and any already sent, have none.
   */
  id: Schema.optional(TrimmedNonEmptyString.check(Schema.isMaxLength(255))),
  name: TrimmedNonEmptyString.check(Schema.isMaxLength(255), Schema.isPattern(/^[^\r\n]+$/)),
  path: DesignSystemMentionPath,
});
export type DesignSystemMention = typeof DesignSystemMention.Type;

export const DesignSystemMentionTarget = Schema.Struct({
  ...DesignSystemMention.fields,
  description: Schema.NullOr(
    TrimmedNonEmptyString.check(Schema.isMaxLength(240), Schema.isPattern(/^[^\r\n]+$/)),
  ),
});
export type DesignSystemMentionTarget = typeof DesignSystemMentionTarget.Type;

export const DesignSystemMentionList = Schema.Array(DesignSystemMention).pipe(
  Schema.withDecodingDefault(Effect.succeed([])),
);
export type DesignSystemMentionList = typeof DesignSystemMentionList.Type;
